import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { orders as ordersApi } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Package, ArrowRight } from 'lucide-react';

const statusColor = {
  placed: 'bg-[#FFF3E0] text-[#9A4500]',
  accepted: 'bg-[#E3F2FD] text-[#0D47A1]',
  preparing: 'bg-[#FFF8E1] text-[#9A7B0A]',
  out_for_delivery: 'bg-[#FCE4EC] text-[#AD1457]',
  delivered: 'bg-[#E8F5E9] text-[#1B5E20]',
  cancelled: 'bg-muted text-ink/60',
  awaiting_payment: 'bg-muted text-ink/60',
};

export default function MyOrders() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (loading) return;
    if (!user) { nav('/'); return; }
    ordersApi.mine().then(setItems).catch(() => setItems([]));
  }, [user, loading, nav]);

  if (loading || !user) return <div className="max-w-5xl mx-auto px-6 py-16 text-ink/60">Loading…</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-6 py-10">
      <h1 className="font-heading font-black text-3xl md:text-4xl">My orders</h1>
      <p className="text-ink/70 mt-1">Track your recent orders and delivery progress.</p>

      <div className="mt-6 space-y-3">
        {items === null ? <div className="text-ink/60">Loading…</div>
        : items.length === 0 ? (
          <div className="card-soft p-10 text-center">
            <Package className="w-10 h-10 mx-auto text-ink/30"/>
            <div className="font-heading font-bold text-xl mt-3">No orders yet</div>
            <Link to="/stores" className="btn-primary mt-5 inline-flex">Start shopping <ArrowRight className="w-4 h-4"/></Link>
          </div>
        ) : items.map(o => (
          <Link key={o.id} to={`/orders/${o.id}`} data-testid={`order-row-${o.id}`} className="card-soft p-4 flex items-center gap-4">
            <div className="w-12 h-12 rounded-lg bg-[#FFF3E0] text-[#E67E22] grid place-items-center"><Package className="w-5 h-5"/></div>
            <div className="flex-1 min-w-0">
              <div className="font-heading font-bold text-ink truncate">{o.store_name}</div>
              <div className="text-xs text-ink/60">{new Date(o.created_at).toLocaleString()} · {o.items.length} items</div>
            </div>
            <span className={`pill !text-[10px] ${statusColor[o.status] || ''}`}>{o.status.replace(/_/g,' ')}</span>
            <div className="font-bold text-ink">₹{o.total.toFixed(2)}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
